import { httpApi } from "./http.api";
import {OrderPayload, PromoCode} from "../@types/signup";

interface ValidateResponse {
    valid: boolean;
    message: string;
}

interface ValidatePromoCodeResponse {
    valid: boolean;
    promo: PromoCode | null;
}

interface GenericResponse {
    success: boolean;
    message: string;
}

export const validatePhoneNumber = async (value: string): Promise<ValidateResponse> => {
    return await httpApi.post<ValidateResponse>(`/signup/validate/phone`, { value }).then(({ data }) => data);
};

export const validatePromoCode = async (promoCode: string): Promise<ValidatePromoCodeResponse> => {
    return await httpApi.post<ValidatePromoCodeResponse>(`/signup/validate/promocode`, { code: promoCode }).then(({ data }) => data);
};

export const submitOrder = async (payload: OrderPayload): Promise<GenericResponse> => {
    return await httpApi.post<GenericResponse>(`/signup/order/submit`, { payload }).then(({ data }) => data);
};
